import TableSystem from './TableSystem';
import './TableSystem.scss';

export default TableSystem;
